import React from "react";
import useAccess from "@hooks/useAccess";
import * as Pages from "@pages";

const PublicOrAuthRoute = ({ element }) => {
    const { canBrowse } = useAccess();

    return canBrowse ? element : <Pages.NoPublicAccessPage />;
};

export default PublicOrAuthRoute;
